<div fxFlex class="terms-of-service" MalihuScrollbar [scrollbarOptions]="scrollbarOptions">
    <app-privacy-policy></app-privacy-policy>
</div>